import Model from "./Model";
import { $constants } from "../plugins/constants";

export default class AtendimentoAEE extends Model {
  constructor(atendimento) {
    super();
    Object.assign(this, atendimento);
    this.descricaoSituacao = this.getDescricaoSituacao();
    this.color = this.getColor();
    this.bimestreDescricao = this.getBimestreDescricao();
  }

  getDescricaoSituacao() {
    if (!this.situacao) return "Aguardando confirmação";
    return this.situacao;
  }

  getColor() {
    const situacao = $constants.situacoesAulas.find(
      (item) => item.descricao === this.descricaoSituacao
    );
    return situacao ? situacao.cor : "success";
  }

  getBimestreDescricao() {
    const bimestre = $constants.bimestres.find((item) => item.value === this.bimestre);
    return bimestre ? bimestre.desc : `Bimestre ${this.bimestre}`;
  }
}
